module.exports = __webpack_public_path__ + "img/1498806952.44f329c0.jpg";